import { MeetingRoom } from '@mui/icons-material';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthenticationContext } from '../../../../context/Authentication';
import useAuth from '../../../../hooks/useAuth';
import './topbar.css';
import { Menu } from '@mui/icons-material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

export default function Topbar({ isSidebarOpen, toggleSidebar }) {
  const { auth, setAuth } = useAuth();
  const authentication = useContext(AuthenticationContext);
  const navigate = useNavigate();
  const logout = () => {
    setAuth({});
    authentication.logout();
    localStorage.removeItem('loginToken');
    navigate('/');
  };
  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
          <button
            className="md:hidden p-2 rounded bg-gray-200 dark:bg-gray-700"
            onClick={toggleSidebar}
          >
            {isSidebarOpen ? (
              <MenuOpenIcon className="text-gray-600 dark:text-gray-300 " />
            ) : (
              <MenuOpenIcon className="text-gray-600 dark:text-gray-300 rotate-180" />
            )}
            {/* <Menu className="text-gray-600 dark:text-gray-300" /> */}
          </button>

          {/* <a href="/" className="link">
            <span className="logo">KnowQuest</span>
          </a> */}
        </div>
        {/* <h1 className="text-lg font-bold text-gray-800 dark:text-white">
          {isSidebarOpen ? 'Sidebar Open' : 'Sidebar Closed'}
        </h1> */}
        <div className="topRight">
          <img
            src="https://www.kindpng.com/picc/m/10-101213_profile-icon-for-the-politics-category-circle-profile.png"
            alt=""
            className="topAvatar"
          />
          {/* <span className="adminUserName">{user.username != undefined ? <span>Hello, {" " + user.username.toUpperCase()}</span> : ''}</span> */}
          <div className="topbarIconContainer">
            <MeetingRoom fontSize="large" onClick={logout} />
          </div>
        </div>
      </div>
    </div>
  );
}
